import Model from 'ducker-model';
import format from '../utils/detail2-format';

const property = {
  assetsData: Object, // 资产信息
  currencyAssetsData: Object, // 货币资产信息
  fundSizeData: Object, // 规模信息
  netAssetsInfo: Object, // 净资产规模（圆环内）
  classificationData: Object, // 分类信息
  industryData: Object, // 行业信息
  topicData: Object, // 主题信息
  couponTypeData: String, // 券种信息
  pointChartData: Object, // 散点图信息 前几期主题分布
  heavyStockRatio: Object, // 重仓股票比例
  heavyStockListInfo: Object, // 重仓股票
  heavyBondListInfo: Object, // 重仓债券
  ETFFeederHeavyFundList: Object, // 重仓基金 ETF联接和FOF是不一样的 分开处理
  FOFHeavyFundList: Object, // 重仓基金 ETF联接和FOF是不一样的 分开处理
  currencyListInfo: Object, // 货币列表
  bonusDetailData: Object, // 分红详情
  quarterlyInfo: Object, // 季报巡检入口
};

const replaceProperty = {
  assetsData: { // 资产信息
    property: ['fundAssetAllocationByDate', 'expansion'],
    computed: ([data, expansion]) => format.handleAssets(data, expansion),
  },
  currencyAssetsData: { // 货币资产信息
    property: 'fundInvestMoneyManagement',
    computed: (data) => format.handleCurrencyAssets(data),
  },
  fundSizeData: { // 规模信息
    property: ['fundBonusDetail', 'fundAssetsList'],
    defaultValue: {},
    computed: ([empty = {}, data = []]) => {
      console.log('empty for model', empty); // 解决model入参为array无法输出object
      return format.handleFundSize(data);
    },
  },
  netAssetsInfo: { // 净资产规模（圆环内）
    property: ['fundAssetAllocationByDate', 'expansion'],
    computed: ([data, expansion]) => format.handleNetAssetsInfo(data, expansion),
  },
  classificationData: { // 分类信息
    property: ['fundInvestDistriTop', 'expansion'],
    computed: ([data, expansion]) => format.handleClassification(data, expansion),
  },
  industryData: { // 行业信息
    property: ['fundSectorAllocationByDate', 'expansion'],
    computed: ([data, expansion]) => format.handleIndustry(data, expansion),
  },
  topicData: { // 主题信息
    property: ['fundStockInvestDistriTop', 'expansion'],
    computed: ([data, expansion]) => format.handleTopic(data, expansion),
  },
  couponTypeData: { // 券种信息
    property: ['expansion', 'fundBondInvestDistri'],
    computed: ([expansion, data]) => format.handleCouponType(data, expansion),
  },
  pointChartData: { // 散点图信息 前几期主题分布
    property: 'fundStockInvestDistriTop',
    defaultValue: {},
  },
  heavyStockRatio: { // 重仓股票比例
    property: 'fundInverstPosition',
    computed: (data) => format.handleHeavyStockRatio(data),
  },
  heavyStockListInfo: { // 重仓股票
    property: ['fundInverstPosition', 'expansion'],
    computed: ([data, expansion]) => format.handleHeavyStockList(data?.fundStocks, expansion),
  },
  heavyBondListInfo: { // 重仓债券
    property: ['fundInverstPosition', 'fundBondInvestDistri', 'expansion'],
    computed: ([data, BondInvestDistri, expansion]) => format.handleHeavyBondList(
      data?.fundboods, BondInvestDistri, expansion,
    ),
  },
  ETFFeederHeavyFundList: {
    property: ['fundAssetAllocationByDate', 'fundInverstPosition', 'expansion'],
    computed: ([AssetAllocation,
      InverstPosition,
      expansion]) => format.handleETFFeederHeavyFundList(
      AssetAllocation, InverstPosition, expansion,
    ),
  },
  FOFHeavyFundList: {
    property: ['fundInverstPosition', 'expansion'],
    computed: ([InverstPosition, expansion]) => format.handleFOFHeavyFundList(
      InverstPosition, expansion,
    ),
  },
  currencyListInfo: { // 货币列表
    property: 'fundInvestMoneyManagement',
    computed: (data) => format.handleCurrencyList(data),
  },
  bonusDetailData: { // 分红详情
    property: 'fundBonusDetail',
    computed: (data) => format.handleBonusDetail(data),
  },
  quarterlyInfo: { // 季报巡检
    property: ['fundBonusDetail', 'fundInvestReport'],
    computed: ([empty = {}, data = []]) => {
      console.log('empty for model', empty); // 解决model入参为array无法输出object
      // 先按照时间分组 因为同一时间可能会同时存在季报 半年报 年报
      const temp = {};
      if (data && data.length) {
        data.forEach((item) => {
          if (item?.REPORTDATE) {
            if (!temp[item.REPORTDATE]) {
              temp[item.REPORTDATE] = [];
            }
            temp[item.REPORTDATE].push(item);
          }
        });
      }

      // 将分组后的数据按照时间排序
      const tempArr = Object.keys(temp).sort((a, b) => (new Date(a?.replace(/-/g, '/')).getTime()
        - new Date(b?.replace(/-/g, '/')).getTime() > 0 ? -1 : 1));
      // 取最新的一条数据 1 年报 2 半年报 3 季报
      const res = temp?.[tempArr[0]] || [];
      // 排序
      res.sort((a, b) => b?.STYLE - a?.STYLE);
      // 取出优先级最高的一条数据
      return res?.[0] || {};
    },
  },
};

export default new Model(property, replaceProperty);
